import BookingDepotService from "../../../services/BookingDepotService"
import { observable, toJS } from "mobx"


export default class AssocDessocStore { 

    @observable listaArmadores;
    @observable listaDepot;
    @observable listaDefault;
    
    @observable armadorSelecionado;
    @observable depotSelecionado;
    @observable qtdDesassociar;
    @observable qtdAssociar;

    @observable salvando;
    @observable loading;

    constructor(depotDefault, booking, operacao, modo) {

        this.booking = booking
        this.modo = modo
        this.operacao = operacao

        this.listaArmadores = []
        this.listaDepot = []
        this.listaDefault = toJS(depotDefault)

        
        this.armadorSelecionado = null
        this.depotSelecionado = null;
        this.qtdDesassociar = ""
        this.qtdAssociar = ""
        this.loading = false
        this.salvando = false

        this.service = new BookingDepotService()
    }

    listarArmadores = () => {
        this.loading = true
        this.service.ListarArmador().then(response => {
            if(response && response.data) {
                this.listaArmadores = this.gerarListaArmadores(
                    response.data.map(armador => {
                        return(
                            {
                                label: armador.ApelidoArmador,
                                value: armador.ArmId
                            }
                        )
                    }),
                    this.listaDefault.map(dflt => dflt.armador)
                )
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loading = false)
    }

    gerarListaArmadores = (all, exclude) => {
        let listaArmadores = all.map(el => {
            if(exclude.find(excl => excl.value === el.value) === undefined) {
                return el
            } else {
                return null
            }
        })

        return listaArmadores.filter(el => el !== null)
    }

    listarDepot = () => {
        this.loading = true
        this.service.ListarDepot().then(response => {
            if(response && response.data) {
                this.listaDepot = response.data.map( depot => {
                    return(
                        {
                            label: depot.ApelidoDepot,
                            value: depot.Id
                        }
                    )
                })
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loading = false)
    }

    setArmador = (value) => {
        this.armadorSelecionado = value
    }

    setDepotDefault = (event, depot, param) => {
        if(param === "armador") {
            if(event === null) {
                this.listaArmadores.push(depot[param])
            } else {
                if(depot[param] !== null) this.listaArmadores.push(depot[param])
                this.listaArmadores = this.gerarListaArmadores(this.listaArmadores, [event])
            }
        }
        depot[param] = event
    }

    setDepotAssoc = (value) => {
        this.depotSelecionado = value;
    }

    setQtdDesassoc = (value) => {
        this.qtdDesassociar = value
    }
    
    setQtdAssoc = (value) => {
        this.qtdAssociar = value
    }

    addArmadorNovo = () => {
        this.listaDefault.push(
            {
                armador:null, 
                depot:null
            }
        )
    }

    delArmador = (index) => {
        this.listaDefault.splice(index,1)
    }


}


// WEBPACK FOOTER //
// ./src/modules/bookingdepot/stores/AssocDessocStore.js